export default __webpack_public_path__ + "static/media/airdockz-wht-2.690c08ec.png";